<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-body">
					<template v-if="item">
						<template v-if="users">
							<template v-if="users.length">
								<div class="row">
									<div class="col-md-12 center">
										<template v-for="value in users">
											<div class="radio radio-success">
												<input @change="changeCoordinator" :id="'user-' + value.id" type="radio" :value="value.id" v-model="user_id">
												<label :for="'user-' + value.id">
													{{ value.email }}
												</label>
											</div>
										</template>
									</div>
								</div>
							</template>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-change-project-coordinator'
				},

				users: null,
				item: null,
				loading:  null,
				user_id: null,
			}
		},
		methods: {
			open(item) {
				this.getUsers()
				this.item = null
				this.user_id = null
				if(item) {
					this.item = item
					this.user_id = item.user_id
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getUsers() {
				this.loading = true
				var data = {
					roles: [
						'admin', 'manager', 'external_manager'
					]
				}
				this.$http.post('admin/roles/users', data)
				.then(response => {
					this.users = response.body
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			changeCoordinator() {
				this.loading = true
				this.$http.get('admin/projects/projects/' + this.item.id + '/change/coordinator/' + this.user_id)
				.then(response => {
					this.close()
					this.loading = false
					this.$emit('reload')
				}).catch(response => {
					console.log(response)
					this.close()
					this.loading = false
					if(response.status == 409) {
						swal({
							title: response.statusText,
							text: response.body,
							type: 'warning',
						})
					}
					this.$emit('reload')
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Coordinator.vue